import { FunctionComponent, useMemo } from 'react';
import { clsx } from 'clsx';
import { Button } from '../../button/Button';
import { getWizardCurrentStepInfo } from '../utils/wizardStepUtil';
import { WizardStepTreeSnapshot } from '../interfaces/wizard-step';
import styles from './WizardFooter.module.scss';

export interface WizardFooterProps {
  back: VoidFunction;
  close: VoidFunction;
  stepTreeSnapshot?: WizardStepTreeSnapshot;
  ExtraComponent?: FunctionComponent<object>;
  extraComponentProps?: object;
}

export function WizardFooter({
  back,
  close,
  stepTreeSnapshot,
  ExtraComponent,
  extraComponentProps = {}
}: WizardFooterProps) {
  const { currentStepGroupIndex, currentStepIndex } = useMemo(() => {
    return getWizardCurrentStepInfo(stepTreeSnapshot);
  }, [stepTreeSnapshot]);

  const backDisabled = currentStepGroupIndex === 0 && currentStepIndex === 0;

  return (
    <div data-id='wizard-footer' className={styles.wizardFooter}>
      <div className='center-flex-row'>
        <Button
          dataId='wizard-footer-back'
          icon='add-arrow-left'
          direction='left'
          variation='outline'
          size='sm'
          onClick={back}
          disabled={backDisabled}
          className={clsx(ExtraComponent && 'mr-5')}
        >
          Back
        </Button>

        {ExtraComponent ? <ExtraComponent {...extraComponentProps} /> : null}
      </div>

      <Button
        dataId='wizard-footer-close'
        icon='close'
        direction='left'
        variation='outline'
        size='sm'
        onClick={close}
      >
        Cancel
      </Button>
    </div>
  );
}
